import { Button } from "@client/components/ui/button";
import {
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from "@client/components/ui/tooltip";
import { authClient } from "@client/lib/auth-client";
import { trpc } from "@client/lib/trpc-client";
import { Link } from "@tanstack/react-router";
import { Zap } from "lucide-react";

export function CreditBalance() {
	const { data: session } = authClient.useSession();

	// Only make the tRPC call if user is authenticated
	const creditBalanceQuery = trpc.credits.getBalance.useQuery(undefined, {
		enabled: !!session?.user, // Only run query if user is authenticated
	});

	const balance = creditBalanceQuery.data?.balance?.balance ?? 0;
	const isLoading = creditBalanceQuery.isLoading;
	const isLow = balance < 100;

	// Don't render anything if user is not authenticated
	if (!session?.user) {
		return null;
	}

	return (
		<TooltipProvider>
			<Tooltip>
				<TooltipTrigger asChild>
					<Button
						variant="outline"
						size="sm"
						className={`flex items-center gap-1.5 px-3 text-sm ${
							isLow ? "border-amber-500/50 text-amber-500" : ""
						}`}
						asChild
					>
						<Link to="/settings/billing">
							<Zap
								className={`h-4 w-4 ${isLow ? "animate-pulse text-amber-500" : "text-primary"}`}
							/>
							<span className={isLoading ? "opacity-50" : ""}>
								{isLoading ? "..." : balance}
							</span>
							<span className="hidden text-muted-foreground sm:inline">
								credits
							</span>
						</Link>
					</Button>
				</TooltipTrigger>
				<TooltipContent>
					<p className="text-sm">Credit balance: {balance}</p>
					<p className="text-muted-foreground text-xs">
						{isLow
							? "Low balance - consider purchasing more"
							: "Click to manage credits"}
					</p>
				</TooltipContent>
			</Tooltip>
		</TooltipProvider>
	);
}
